var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS1LocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 33.5H4",
    stroke: "#747474",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 0C5.20509 0 0 5.20509 0 11.625C0 14.153 0.828766 16.4726 2.20633 18.3723C2.23103 18.4179 2.23491 18.4687 2.263 18.5123L10.013 30.1373C10.3724 30.6764 10.9779 31 11.625 31C12.2721 31 12.8776 30.6764 13.237 30.1373L20.987 18.5123C21.0156 18.4687 21.019 18.4179 21.0437 18.3723C22.4212 16.4726 23.25 14.153 23.25 11.625C23.25 5.20509 18.0449 0 11.625 0ZM11.625 15.5C9.48503 15.5 7.75 13.765 7.75 11.625C7.75 9.48503 9.48503 7.75 11.625 7.75C13.765 7.75 15.5 9.48503 15.5 11.625C15.5 13.765 13.765 15.5 11.625 15.5Z",
    fill: "#F37A50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1LocIcon);
export default __webpack_public_path__ + "static/media/s1-loc-icon.be069e7c83ad65d4f6c93c683283a48f.svg";
export { ForwardRef as ReactComponent };